import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const form = css`
  width: 100%;
  max-width: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: unset;

  @media (max-width: ${dimensions.phoneMax}) {
    max-width: 25.91rem;
  }
`;

export const marginBottom = css`
  margin-bottom: 1rem;
`;

export const Row = css`
  display: flex;
  width: 100%;
  ${marginBottom};

  @media (max-width: ${dimensions.phoneMax}) {
    flex-direction: column;
  }
`;

export const margin = css`
  margin-right: 1rem;

  @media (max-width: ${dimensions.phoneMax}) {
    margin-right: 0;
    ${marginBottom};
  }
`;

export const fieldset = css`
  border: none;
  width: 100%;
`;

export const formWrapper = (isStorefronts: boolean) => css`
  padding-top: ${isStorefronts ? "0" : "2rem"};
  max-width: ${isStorefronts ? "34rem" : undefined};
`;

export const buttonStyles = css`
  width: unset;
`;

export const buttonWrapper = css`
  text-align: center;
  max-width: max-content;
`;
